import { IResponse } from '@zmedia/bm-soccer-ui/interface';
import { getWithPath } from '@zmedia/bm-soccer-ui/utils/http';

const API_PATH = {
    GET_LINEUP: '/match/get/lineup',
    GET_STATS: '/match/get/stats',
    GET_EVENTS: '/match/get/events',
    GET_LIST: '/match/get/list',
    GET_PEN_SHOOTOUT: '/match/get/penalties-shootout',
    GET_PREDICT: '/match/get/predict'
};

export const MatchService = {
    getLineup: (id: number): Promise<IResponse<any>> => {
        return getWithPath(API_PATH.GET_LINEUP, { id });
    },
    getStats: (id: number): Promise<IResponse<any>> => {
        return getWithPath(API_PATH.GET_STATS, { id });
    },
    getEvents: (id: number): Promise<IResponse<any>> => {
        return getWithPath(API_PATH.GET_EVENTS, { id });
    },
    getList: (params: any): Promise<IResponse<any>> => {
        return getWithPath(API_PATH.GET_LIST, params);
    },
    getPenShootout: (id: number): Promise<IResponse<any>> => {
        return getWithPath(API_PATH.GET_PEN_SHOOTOUT, { id });
    },
    getPredict: (id: number): Promise<IResponse<any>> => {
        return getWithPath(API_PATH.GET_PREDICT, { id });
    },
};

export default MatchService;
